import { TableCellsIcon } from '@heroicons/react/24/outline';
import { Button } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { eAgendaTabs } from '../Calendar.enums';
import { useCalendarContext } from '../Calendar.hook';
import { NoEventsProps } from '../Calendar.types';

export default function NoEventsOrTemplate({ hasTemplates }: NoEventsProps) {
  const { t } = useTranslation();
  const { setCurrentTab, setShowCreateEvent } = useCalendarContext();

  return (
    <div className="flex flex-col w-full p-4 bg-base-100 rounded-sm">
      <div className="flex flex-row justify-center my-4 text-lg ">
        {t('agenda/agenda:event-list')}
      </div>
      {/*<img src={'/images/agenda/agenda-arrow.png'} alt="arrow" className="w-14 mx-auto absolute right-0 mr-60 " />  //TODO search for a way to paste over*/}
      <div className="flex flex-row border-dashed border-2 justify-center px-72 py-12">
        <div className="flex flex-col text-center">
          <img
            src={'/images/agenda/calendar.icon.png'}
            alt="calendar"
            className="w-20 h-20 mx-auto mb-4 "
          />
          {hasTemplates !== 0 ? (
            <>
              <p className="font-bold text-lg">
                {t('agenda/agenda:create-your-new-event')}
              </p>
              <p>{t('agenda/agenda:events-description-events')}</p>
            </>
          ) : (
            <>
              <p className="font-bold text-lg">
                {t('agenda/agenda:welcome-to-agenda')}
              </p>
              <p>{t('agenda/agenda:events-description')}</p>
            </>
          )}

          <div className="flex flex-row justify-center mt-4">
            <Button
              color="primary"
              startIcon={<TableCellsIcon className="w-6 h-6" />}
              onClick={() => {
                if (hasTemplates !== 0) {
                  setShowCreateEvent(true);
                } else {
                  setCurrentTab(eAgendaTabs.TEMPLATES);
                }
              }}
            >
              {hasTemplates !== 0
                ? t('agenda/agenda:create-your-first-event')
                : t('agenda/agenda:create-one-template')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
